// permissions.ts — who can see what, by OMS user id.
//
// These are UI gates only; the backend enforces the same lists (see
// backend/src/middleware/auth.middleware.js — ownerAuth / productLinksAuth).
// Change both sides together.

export const OWNER_USER_ID = 1; // Magnus

/**
 * Users allowed to see product sourcing links. The links reveal the supplier,
 * so this is an explicit allowlist rather than "any OMS admin".
 *   1  = Magnus (owner)
 *   12 = Adam
 */
export const PRODUCT_LINK_VIEWER_IDS: number[] = [OWNER_USER_ID, 12];

export function canViewProductLinks(userId?: number | null): boolean {
  return userId != null && PRODUCT_LINK_VIEWER_IDS.includes(Number(userId));
}

// ---- roles ----------------------------------------------------------------
//
// Mirrors OMS_ROLES in backend/src/middleware/auth.middleware.js.
//   admin   — full dashboard.
//   counter — NOKE 門市人員: the NOKE screens, the Threads 海巡 log, and
//             logout, nothing else.
//
// The backend is the real gate (counterAuth is mounted on /api/noke and
// /api/threads-patrol, and no other router). Everything below is so the UI
// doesn't offer what the API would refuse.

export type OmsRole = 'admin' | 'counter';

/**
 * The only paths a `counter` account may open. First entry is its home.
 * /noke/clock is the 打卡 screen — the backend admits counter accounts to
 * /api/employee/punch* for it (see employee.routes.js COUNTER_ALLOWED_PATHS)
 * and to nothing else on that router.
 * /threads-patrol is the Threads 海巡 work log — counter-wide, not NOKE-only,
 * because the work is brand marketing done in counter dead time rather than
 * anything the counter itself owns.
 */
export const COUNTER_ALLOWED_PATHS = ['/noke', '/noke/pos', '/noke/clock', '/threads-patrol'] as const;

export const COUNTER_HOME_PATH = COUNTER_ALLOWED_PATHS[0];

export function isCounterRole(role?: string | null): boolean {
  return role === 'counter';
}

export function canAccessPath(role: string | null | undefined, path: string): boolean {
  if (!isCounterRole(role)) return true;
  return (COUNTER_ALLOWED_PATHS as readonly string[]).includes(path);
}
